import { createBrowserRouter } from 'react-router-dom';
import App from '../App';
import { Home, About, Clients, Gallery, Videos, NotFoundPage } from "../Pages/export"
import { Contact } from '../components/Contact';

const routes = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "clients",
        element: <Clients />,
      },
      {
        path: "gallery",
        element: <Gallery />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "videos",
        element: <Videos />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
]);

export default routes;
